export default class TypesDomain {
    constructor(domain, storage) {
      this.domain = domain;
      this.storage = storage;
    }
}